export enum EnumTipoRelacionProductoConcepto {
  Obligatorio = 1,
  Opcional = 2,
  Condicional = 3
}
